import { Select } from 'antd';
import React from 'react';
import { BootAnimationScreens } from '../../../constants';

function SelectBootAnimation({ value, onChange, ...other }) {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="Select a call center"
      allowClear
      {...other}
    >
      {BootAnimationScreens.map((field) => (
        <Select.Option key={field.key} value={field.key}>
          {field.label}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SelectBootAnimation;
